import { Routes, Route } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'
import { Toaster } from 'react-hot-toast'
import Navbar from '@/components/Navbar'
import HomePage from '@/pages/HomePage'
import AuditPage from '@/pages/AuditPage'
import AnonymousAuditPage from '@/pages/AnonymousAuditPage'
import ReportsPage from '@/pages/ReportsPage'
import ReportDetailPage from '@/pages/ReportDetailPage'
import LocalAuditPage from '@/pages/LocalAuditPage'
import ComparisonPage from '@/pages/ComparisonPage'
import SettingsPage from '@/pages/SettingsPage'
import LoginPage from '@/pages/LoginPage'
import SubscribePage from '@/pages/SubscribePage'
import RequireAuth from '@/components/RequireAuth'

export default function App() {
  return (
    <div className="min-h-screen flex flex-col" style={{ background: 'var(--bg-base)' }}>
      <Navbar />
      <main className="flex-1">
        <AnimatePresence mode="wait">
          <Routes>
            {/* Public — no auth needed. HomePage branches internally on auth state. */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/subscribe" element={<SubscribePage />} />
            <Route path="/" element={<HomePage />} />
            <Route path="/audit-demo/:id" element={<AnonymousAuditPage />} />

            {/* Gated routes — RequireAuth bounces anonymous users to /login. */}
            <Route path="/audit/:id" element={<RequireAuth><AuditPage /></RequireAuth>} />
            <Route path="/audit-local" element={<RequireAuth><LocalAuditPage /></RequireAuth>} />
            <Route path="/reports" element={<RequireAuth><ReportsPage /></RequireAuth>} />
            <Route path="/reports/:id" element={<RequireAuth><ReportDetailPage /></RequireAuth>} />
            <Route path="/compare/:idA/:idB" element={<RequireAuth><ComparisonPage /></RequireAuth>} />
            <Route path="/settings" element={<RequireAuth><SettingsPage /></RequireAuth>} />
          </Routes>
        </AnimatePresence>
      </main>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: 'rgba(20, 20, 28, 0.92)',
            color: 'var(--text-primary)',
            border: '1px solid rgba(255,255,255,0.08)',
            backdropFilter: 'blur(12px)',
            fontSize: '13px',
          },
          success: { iconTheme: { primary: '#22c55e', secondary: '#0a0a0f' } },
          error:   { iconTheme: { primary: '#ef4444', secondary: '#0a0a0f' } },
        }}
      />
    </div>
  )
}
